import React from "react";
import TaskForm from "../forms/TaskForm";
import PatrolForm from "../forms/PatrolForm";

export default function Modal({ type, open, onClose, entity, setFormIsDirty }) {
  //if (!entity) return null; - @TODO commented to allow Add Task
  return (
    <>
      {type == 'TASK' && (
        <TaskForm setFormIsDirty={setFormIsDirty} open={open} onClose={onClose} entity={entity} />
      )}
      {type == "PATROL" && (
        <PatrolForm open={open} onClose={onClose} entity={entity}/>
      )}
    </>
  );
}
